import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://nlgyziugqufvspedsghq.supabase.co';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5sZ3l6aXVncXVmdnNwZWRzZ2hxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY0MTYyNzAsImV4cCI6MjA5MTk5MjI3MH0.n2atrZxFgcX738vpsO97Dk0U2O8aoElt0Jqyuv-UhMk';

if (!process.env.REACT_APP_SUPABASE_URL || !process.env.REACT_APP_SUPABASE_ANON_KEY) {
  console.warn('Supabase credentials not found in environment variables. Using fallback values.');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
